export function ExpiredLinkPage({ reason }: { reason: 'expired' | 'revoked' }) {
  const title = reason === 'expired' ? 'This link has expired' : 'This link is no longer active';
  const body =
    reason === 'expired'
      ? 'The shared chart link has reached its expiration time.'
      : 'The clinician who generated this link has revoked it.';
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-3">
        <h1 className="text-xl font-semibold">{title}</h1>
        <p className="text-sm text-muted-foreground">{body}</p>
        <p className="text-xs text-muted-foreground">
          Please contact the sharing clinician for a new link.
        </p>
      </div>
    </div>
  );
}
